// Attaches a stylsheet and returns a promise
//  fulfilled when styles have been loaded
//  Adapted from: http://www.phpied.com/when-is-a-stylesheet-really-loaded/
export default function attachStylesheet(url) {
  return new Promise(function (resolve) {
    const style = document.createElement('style');
    style.textContent = `@import '${url}'`;

    var i = setInterval((function () {
      try {
        const x = style.sheet.cssRules;
        resolve(x);
        return clearInterval(i);
      } catch (error) {
      }
    }), 10);

    return document.body.appendChild(style);
  });
}